import { render } from "./TeamInfoView.vue?vue&type=template&id=6f06bbc8&scoped=true"
import script from "./TeamInfoView.vue?vue&type=script&lang=js"
export * from "./TeamInfoView.vue?vue&type=script&lang=js"

import "./TeamInfoView.vue?vue&type=style&index=0&id=6f06bbc8&lang=scss"
import "./TeamInfoView.vue?vue&type=style&index=1&id=6f06bbc8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f06bbc8"]])

export default __exports__